<script setup lang="ts">
import { ref } from 'vue';
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import axios from 'axios'

const emit = defineEmits(['close']);
const range = ref("Week");
const isDownloading = ref(false);

async function handleGenerate() {
  isDownloading.value = true;

  try {
    const response = await axios.post('/api/v1/tasks/export_search',
      { period: range.value.toLowerCase() },
      { responseType: 'blob' }
    );

    // Axios stores the binary data in .data
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `search-analytics-${range.value.toLowerCase().replace(' ', '-')}.csv`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    emit('close');
  } catch (error) {
    console.error("Export Error:", error);
    alert("Failed to export data.");
  } finally {
    isDownloading.value = false;
  }
}
</script>

<template>
  <DialogContent @pointerDownOutside="$emit('close')" @close="$emit('close')">
    <DialogHeader>
      <DialogTitle>Export Search Analytics</DialogTitle>
      <DialogDescription>
        Select the time range for the CSV export.
      </DialogDescription>
    </DialogHeader>

    <div class="flex flex-col gap-4 py-4">
      <Select v-model="range">
        <SelectTrigger>
          <SelectValue placeholder="Select range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Week">Week</SelectItem>
          <SelectItem value="Month">Month</SelectItem>
        </SelectContent>
      </Select>
    </div>

    <DialogFooter>
      <Button variant="secondary" @click="$emit('close')">Cancel</Button>
      <Button 
        @click="handleGenerate" 
        :disabled="isDownloading"
      >
        {{ isDownloading ? 'Generating...' : 'Generate' }}
      </Button>
    </DialogFooter>
  </DialogContent>
</template>
